import { useEffect, useRef, useState } from "react";

// Gilded ignition — lights a single gold sweep across an element the first time
// it strikes into view. Returns [ref, lit]; pair with the `ignite`/`ignite--lit`
// CSS classes.
export function useIgnite(amount = 0.6) {
  const ref = useRef(null);
  const [lit, setLit] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setLit(true);
          io.disconnect();
        }
      },
      { threshold: amount }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [amount]);
  return [ref, lit];
}
